import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["radius", "stroke", "currentStep", "totalSteps", "$css"];
import React from 'react';
import styled, { css } from 'styled-components';
import { VisuallyHidden } from '@figure/frontlib-accessibility';
import { TYPOGRAPHY, COLORS } from '../../../themes';
import Svg from '../../svg/Svg';
import { Span } from '../../Styled';
var Circle = /*#__PURE__*/styled.circle.withConfig({
  displayName: "ProgressRing__Circle",
  componentId: "sc-1e3vcca-0"
})(["transition:stroke-dashoffset 0.35s;transform:rotate(-90deg);transform-origin:50% 50%;"]);
var Circle2 = /*#__PURE__*/styled(Circle).withConfig({
  displayName: "ProgressRing__Circle2",
  componentId: "sc-1e3vcca-1"
})(["animation:percent 1.5s linear;animation-delay:1s;"]);
var CircleText = /*#__PURE__*/styled.text.withConfig({
  displayName: "ProgressRing__CircleText",
  componentId: "sc-1e3vcca-2"
})(["", ";dominant-baseline:middle;text-anchor:middle;fill:", ";"], TYPOGRAPHY.S_SEMIBOLD, COLORS.NEUTRAL_550);

var ProgressRing = function ProgressRing(_ref) {
  var _ref$radius = _ref.radius,
      radius = _ref$radius === void 0 ? 24 : _ref$radius,
      _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? 2 : _ref$stroke,
      _ref$currentStep = _ref.currentStep,
      currentStep = _ref$currentStep === void 0 ? 0 : _ref$currentStep,
      _ref$totalSteps = _ref.totalSteps,
      totalSteps = _ref$totalSteps === void 0 ? 1 : _ref$totalSteps,
      $css = _ref.$css,
      rest = _objectWithoutProperties(_ref, _excluded);

  var normalizedRadius = radius - stroke / 2;
  var circumference = normalizedRadius * 2 * Math.PI;
  var strokeDashoffset = circumference - currentStep * 100 / (100 * totalSteps) * circumference;
  return /*#__PURE__*/React.createElement(Span, _extends({
    $css: css(["display:inline-block;", ""], $css)
  }, rest), /*#__PURE__*/React.createElement(Svg, {
    height: "".concat(radius * 2 / 10, "rem"),
    width: "".concat(radius * 2 / 10, "rem")
  }, /*#__PURE__*/React.createElement(Circle, {
    stroke: COLORS.NEUTRAL_200,
    fill: "transparent",
    strokeWidth: stroke,
    style: {
      strokeDashoffset: strokeDashoffset
    },
    "stroke-width": stroke,
    r: normalizedRadius,
    cx: radius,
    cy: radius
  }), /*#__PURE__*/React.createElement(Circle2, {
    stroke: COLORS.SECONDARY_300,
    fill: "transparent",
    strokeWidth: stroke,
    strokeDasharray: "".concat(circumference, " ").concat(circumference),
    style: {
      strokeDashoffset: strokeDashoffset
    },
    "stroke-width": stroke,
    r: normalizedRadius,
    cx: radius,
    cy: radius
  }), /*#__PURE__*/React.createElement(CircleText, {
    x: "50%",
    y: "52%",
    "aria-hidden": true
  }, currentStep, "/", totalSteps)), /*#__PURE__*/React.createElement(VisuallyHidden, null, "step ", currentStep, " of ", totalSteps));
};

export default ProgressRing;